var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioOnboardingHeartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.4541 16.2529C8.64746 16.2529 8.92676 16.124 9.12012 15.9951C13.9434 12.9443 16.9082 9.37793 16.9082 5.73633C16.9082 2.70703 14.8242 0.558594 12.1494 0.558594C10.4629 0.558594 9.23828 1.48242 8.4541 2.87891C7.68066 1.49316 6.44531 0.558594 4.75879 0.558594C2.08398 0.558594 0 2.70703 0 5.73633C0 9.37793 2.96484 12.9443 7.78809 15.9951C7.98145 16.124 8.27148 16.2529 8.4541 16.2529Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOnboardingHeartIcon);
export default __webpack_public_path__ + "static/media/audio_onboarding_heart_icon.bb0ea44fc622c46a1df9c533fed9b007.svg";
export { ForwardRef as ReactComponent };